import { createSelector } from 'reselect';

import { LoanHeaderViewType } from 'constants/loanApplication';
import { groupLoanHeaderViewItemsByColumn } from 'utils/loanHeaderView';

import { selectLoanApplication } from './loanApplication.selectors';
import { selectLoanMilestoneStatusName } from './loanApplicationCommonInfo.selectors';

export const selectIsApplicationHeaderViewLoading = createSelector(
  [selectLoanApplication],
  ({ headerView }) => headerView?.isLoading,
);

const selectApplicationHeaderView = createSelector(
  [selectLoanApplication],
  ({ headerView }) => headerView?.items,
);

export const selectPrimaryLoanHeaderView = createSelector(selectApplicationHeaderView, items =>
  groupLoanHeaderViewItemsByColumn(items, LoanHeaderViewType.PRIMARY),
);

export const selectSecondaryLoanHeaderView = createSelector(selectApplicationHeaderView, items =>
  groupLoanHeaderViewItemsByColumn(items, LoanHeaderViewType.SECONDARY),
);

export const selectLoanStatusHeaderValue = selectLoanMilestoneStatusName;
